<template>
    <div
        class="application-root"
        style="
            justify-content: space-between;
            align-items: stretch;
            display: flex;
            width: 100%;
            min-width: 0;
        "
    >
        <router-view @download-csv="(args) => download_csv(...args)"></router-view>
    </div>
</template>

<script>
    // import DataTable from './components/shared/DataTable.vue';
    import DataFrame from 'dataframe-js'
    import moment from 'moment'
    import { AUTH_AND_INITIALIZE, ACCOUNTS_LOGIN } from '@/data/url'
    import { useDropdownsStore } from '@/stores/dropdownsStore'
    import { mapStores } from 'pinia'
    import { useSessionStore } from '@/stores/sessionStore'
    import { useUserStore } from '@/stores/userStore'
    import { useSearchStore } from '@/stores/searchStore'
    import config from '@/services/config'

    export default {
        name: 'app',
        components: {
            // NavTop,
        },
        data() {
            return {
                url: AUTH_AND_INITIALIZE,
                loginUrl: ACCOUNTS_LOGIN,
            }
        },
        created: function () {
            if (config.isSearchDemo()) {
                document.title = 'SourceHatch Demo'
            } else {
                document.title = config.isInvoiceDashboard()
                    ? 'GPIQ Invoice Intelligence'
                    : 'Greenwood Parts'
            }
        },
        mounted: function () {
            // this.ajax_auth_and_initialize()
            // this.check_session()
        },
        computed: {
            ...mapStores(useSessionStore, useUserStore, useSearchStore),
        },
        methods: {
            check_session: function () {
                // Check at specified intervals if the session will expiring soon
                let interval = 3600000 // one hour in milliseconds
                const expires = this.sessionStore.sessionExpiry
                if (expires == '') {
                    setTimeout(this.check_session, interval)
                    return
                }
                this.sessionStore.setSession(expires)
                setTimeout(this.check_session, interval)
            },

            ajax_auth_and_initialize() {
                // const url = this.apiUrl + this.url
                const url = this.url

                fetch(url, {
                    method: 'GET',
                })
                    .then((res) => res.json())
                    .then((res) => {
                        const user = res.user || {}
                        const dropdowns = res.user?.dropdowns || res.dropdowns || {}
                        const sessionExpiry = res.session_expiry || res.user?.session_expiry || ''
                        const permissions =
                            res.search_parts_permissions || res.user?.search_parts_permissions || []

                        this.setUser(user)
                        this.setDropdowns(dropdowns)
                        this.setSessionExpiry(sessionExpiry)
                        this.setSearchPartsPermissions(permissions)
                        if (res.success) {
                            // console.log(res)
                        } else {
                            this.notAuthenticated()
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                        this.notAuthenticated()
                    })
            },
            setUser(user) {
                this.userStore.setUser(user)
            },
            setDropdowns(dropdowns) {
                try {
                    const dropdownsStore = useDropdownsStore()
                    dropdownsStore.setDropdowns(dropdowns)
                } catch (error) {
                    console.error('Failed to sync dropdowns into Pinia store', error)
                }
            },
            setSearchPartsPermissions(permissions) {
                this.searchStore.set_search_parts_permissions(permissions || [])
            },
            setSessionExpiry(expires) {
                this.sessionStore.setSession(expires)
            },
            notAuthenticated() {
                // show login if not authenticated
                this.userStore.setUser({ test: 'NONE' })
                // alert('Error: Not logged in!')
                let login_url = this.loginUrl
                let current_url = this.$route.fullPath
                if (!current_url.includes(login_url)) {
                    let next = encodeURIComponent(`/#${current_url}`)
                    login_url += `?next=${next}`
                }
                // window.location.href = login_url // redirect to login
            },
            ajax_check_auth: function () {
                let url = '/ajax/is_authenticated'
                this.userStore.setUser({ test: 'test' })
                function set_user(user) {
                    const userStore = useUserStore()
                    userStore.setUser(user)
                }
                function not_authenticated() {
                    // show login if not authenticated
                    const userStore = useUserStore()
                    userStore.setUser({ test: 'NONE' })
                    alert('Error: Not logged in!')
                }
                fetch(url, {
                    method: 'GET',
                })
                    .then((res) => res.json())
                    .then((res) => {
                        set_user(res)
                        if (res.is_authenticated) {
                            // console.log(res)
                        } else {
                            not_authenticated()
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                        not_authenticated()
                    })
            },
            titleCase(str) {
                // // Replace underscore with space
                // let spaced = str.replace(/_/g, ' ')
                return str
                    .toLowerCase()
                    .split('_')
                    .map(function (word) {
                        return word.replace(word[0], word[0].toUpperCase())
                    })
                    .join(' ')
            },
            // download-csv: function(arg1, arg2,){
            // },
            download_csv(data, filename = 'download', columns = null, rename = true) {
                //
                // Download data to csv
                // data: data to download in array of dictionaries
                // filename: string to be included in filename
                //           (automatically prefixed with date and postfixed with .csv)
                // columns: Optional array of columns to select from dataframe
                // -------------------------------------------

                // Create dataframe from data
                let df = new DataFrame(data)
                if (columns) {
                    // Select specific columns
                    df = df.select(...columns)
                }

                // Rename columns in title case
                if (rename) {
                    for (let column of df.listColumns()) {
                        df = df.rename(column, this.titleCase(column))
                    }
                }

                // Create CSV and download via browser
                let csv = df.toCSV(df)
                // Create blob / url to download CSV file
                const url = window.URL.createObjectURL(new Blob([csv]))

                var element = document.createElement('a')
                element.setAttribute('href', url)
                let m = moment()
                let date = m.format('YYYY-MM-DD.HH.mm.ss')
                element.setAttribute('download', date + '_' + filename + '.csv')

                element.style.display = 'none'
                document.body.appendChild(element)

                element.click()

                // Remove element and file from memory
                document.body.removeChild(element)
                window.URL.revokeObjectURL(url)
            },
        },
    }
</script>

<style>
    .btn-danger,
    .badge-danger {
        background-color: var(--color-brand-primary) !important;
    }

    .text-danger {
        color: var(--color-brand-primary) !important;
    }

    .card {
        border-top: 4px solid var(--color-brand-primary);
    }
</style>
